type NormalizationType = "NATIVE" | "LINE_NORMALIZED";

const normalizationTypeKeys: NormalizationType[] = [
  "NATIVE",
  "LINE_NORMALIZED",
];

const isNormalizationType = (value: string): value is NormalizationType => {
  return normalizationTypeKeys.indexOf(value as NormalizationType) > -1;
};

const getNormalizationTypes = () => {
  return [...normalizationTypeKeys];
};

const getNormalizationTypeDisplayValue = (key: NormalizationType): string => {
  switch (key) {
    case "NATIVE":
      return "Native Span Order";
    case "LINE_NORMALIZED":
      return "Line Normalized";
    default:
      throw new Error(`Value ${key} is not a NormalizationType`);
  }
};

export {
  NormalizationType,
  isNormalizationType,
  getNormalizationTypes,
  getNormalizationTypeDisplayValue,
};
